<ac-loader *ngIf="isLoading" [loaderMessage]="'Loading..'"></ac-loader>
<div class="container login-block">
  <div class="row row-mar-30">
    <div class="col-sm-4 width-sm-100 padding-lg-rit-22">
      <div id="okta-signin-container"></div>
    </div>
    <div class="col-sm-8 width-sm-100 callout-item" *ngIf="isDataAvailable">
      <div class="">
        <h2>{{ loginData.data[0].heading }}</h2>
        <p>{{ loginData.data[0].description }}</p>
        <ul class="dashed">
          <li *ngFor="let item of loginData.data[0].displayItems">
            {{ item.description }}
          </li>
        </ul>
      </div>
      <div><p [innerHTML]="loginData.data[0].text"></p></div>
    </div>
  </div>
</div>

<!--Media Block-->
<div class="media-content">
  <div class="container" id="custom-container" *ngIf="isDataAvailable">
    <div class="row">
      <div class="col-sm-12 col-md-5 media-text">
        <p>
          {{ loginData.media[0].description }}
        </p>
      </div>
      <div class="col-sm-12 col-md-7 spacing">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            [src]="mediaURL"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Featured Product-->
<div *ngIf="isDataAvailable">
  <feature-products [featureProd]="loginData"></feature-products>
</div>
